<template>
  <div class="container">
    <HomeHeader @filter-changed="updateFilter"></HomeHeader>
    <main>
      <HomeVideoItem
        v-for="video in filteredVideos"
        :key="video.id"
        :id="video.id"
        :title="video.title"
        :url="video.url"
        :subTitle="video.subTitle"
        :videoTag="video.videoTag"
        :recommended="video.recommended"
        :liked="video.liked"
        @update-liked="updateLikedStatus"
        v-bind="video"
      ></HomeVideoItem>
    </main>
    <AppFooter></AppFooter>
  </div>
</template>
<style>
/* --------------------- content ---------------------*/

main {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
</style>

<script>
import HomeHeader from "@/components/HomeHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import HomeVideoItem from "@/components/HomeVideoItem.vue";
import videoAPI from "@/api/videoAPI.js";
// import { mapState } from "vuex";

export default {
  components: {
    // Register the CookieTimer component
    HomeHeader,
    HomeVideoItem,
    AppFooter,
  },
  data() {
    return {
      videoList: [],
      currentFilter: "all",
    };
  },
  computed: {
    // ...mapState(["user"]),
    filteredVideos() {
      switch (this.currentFilter) {
        case "recommend":
          return this.videoList.filter((video) => video.recommended);
        case "like":
          return this.videoList.filter((video) => video.liked);
        default:
          return this.videoList;
      }
    },
  },
  async mounted() {
    const storedList = sessionStorage.getItem("videoList");
    if (storedList) {
      this.videoList = JSON.parse(storedList);
    } else {
      this.videoList = await videoAPI.getVideos();
    }
  },
  watch: {
    videoList: {
      deep: true,
      handler(newList) {
        // console.log('watch');
        sessionStorage.setItem("videoList", JSON.stringify(newList));
      },
    },
  },
  methods: {
    updateLikedStatus(payload) {
      const video = this.videoList.find((video) => video.id === payload.id);
      if (video) {
        video.liked = payload.liked;
      }
    },
    updateFilter(filterName) {
      this.currentFilter = filterName;
    },
  },
};
</script>
